module.exports = __webpack_public_path__ + "img/betsoft.0f9d9c95.svg";